/**
 * Light, dark, or whatever the system says (the default).
 *
 * Stored per browser, like the sidebar's state: a convenience, so a browser
 * that refuses storage simply follows the system. `index.css` does the rest
 * from the `data-theme` attribute on <html>.
 */

export type Theme = "system" | "light" | "dark";

const KEY = "futureminds.admin.theme";

export function storedTheme(): Theme {
  try {
    const value = localStorage.getItem(KEY);
    return value === "light" || value === "dark" ? value : "system";
  } catch {
    return "system";
  }
}

export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  if (theme === "system") delete root.dataset.theme;
  else root.dataset.theme = theme;
  try {
    if (theme === "system") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, theme);
  } catch {
    // Nothing to do: see storedTheme.
  }
}

export const NEXT: Record<Theme, Theme> = { system: "light", light: "dark", dark: "system" };
